import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=57a04a1c&"
import script from "./Upload.js?vue&type=script&lang=js&"
export * from "./Upload.js?vue&type=script&lang=js&"
import style0 from "./Upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn,QImg,QCircularProgress,QTooltip,QColor});
